'use client'

import { ReactNode } from 'react'
import { Image, Spacer, Text } from '@vinted/web-ui'

type Props = {
  label: string
  messages: Array<ReactNode>
  avatarImageSrc: string
}

const ConversationExample = ({ label, messages, avatarImageSrc }: Props) => {
  const renderMessage = (message: ReactNode, index: number) => (
    <div key={index}>
      <div className="phishing-first-time-lister-education__message">{message}</div>
    </div>
  )

  return (
    <>
      <Text as="span" text={label} type={Text.Type.Body} bold />
      <Spacer size={Spacer.Size.Large} />
      <div className="phishing-first-time-lister-education__conversation">
        <div className="phishing-first-time-lister-education__avatar">
          <Image src={avatarImageSrc} styling={Image.Styling.Circle} size={Image.Size.Medium} />
        </div>
        <div className="phishing-first-time-lister-education__messages-container">
          {messages.map(renderMessage)}
        </div>
      </div>
    </>
  )
}

export default ConversationExample
